//# sourceMappingURL=layout.mjs.map
/// <reference types="./layout.d.mts" />
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $attribute from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $s from "../../../sketch_redraw/sketch/redraw.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

class Gap extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Align extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Justify extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Flex extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Tag extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Padding extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Position extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Overflow extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Class extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Wrap extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class WhiteSpace extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Shrink extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}

class Attributes extends $CustomType {
  constructor(gap, align, justify, flex, tag, padding, position, overflow, class$, wrap, whitespace, shrink) {
    super();
    this.gap = gap;
    this.align = align;
    this.justify = justify;
    this.flex = flex;
    this.tag = tag;
    this.padding = padding;
    this.position = position;
    this.overflow = overflow;
    this.class = class$;
    this.wrap = wrap;
    this.whitespace = whitespace;
    this.shrink = shrink;
  }
}

export function styles(class$) {
  return new Class($css.class$(class$));
}

export function overflow(value) {
  return new Overflow(value);
}

export function gap(value) {
  return new Gap(value);
}

/**
 * Controls the cross-axis alignment of items.
 *
 * In a `row` it's the vertical axis, and in a `column` the horizontal axis.
 *
 * ```
 * l.row([l.align("center")], [], items)
 * // ┌───────────┐    ┌───────────┐
 * // │          ■│    │           │
 * // │■   ■ ■ ■  │ -> │■ ■ ■ ■ ■ ■│
 * // │  ■        │    │           │
 * // └───────────┘    └───────────┘
 * l.column([l.align("start")], [], items)
 * // ┌─────┐    ┌─────┐
 * // │  ■  │    │■    │
 * // │  ■  │ -> │■    │
 * // │  ■  │    │■    │
 * // └─────┘    └─────┘
 * ```
 * [MDN Reference](https://developer.mozilla.org/fr/docs/Web/CSS/Reference/Properties/align-items)
 */
export function align(value) {
  return new Align(value);
}

/**
 * Controls the main-axis distribution of items.
 *
 * In a `row` it's the horizontal axis, and in a `column` the vertical axis.
 *
 * ```
 * l.row([l.justify("space-between")], [], items)
 * // ┌───────────┐    ┌───────────┐
 * // │■ ■ ■      │ -> │■    ■    ■│
 * // └───────────┘    └───────────┘
 * l.column([l.justify("center")], [], items)
 * // ┌─────┐    ┌─────┐
 * // │  ■  │    │     │
 * // │  ■  │    │  ■  │
 * // │  ■  │ -> │  ■  │
 * // │     │    │  ■  │
 * // │     │    │     │
 * // └─────┘    └─────┘
 * ```
 * [MDN Reference](https://developer.mozilla.org/fr/docs/Web/CSS/Reference/Properties/justify-content)
 */
export function justify(value) {
  return new Justify(value);
}

export function flex(value) {
  return new Flex(value);
}

export function tag(value) {
  return new Tag(value);
}

export function padding(value) {
  return new Padding(value);
}

export function position(value) {
  return new Position(value);
}

export function wrap(value) {
  return new Wrap(value);
}

export function white_space(value) {
  return new WhiteSpace(value);
}

export function shrink(value) {
  return new Shrink(value);
}

function compute_attributes(attrs) {
  let new$ = new Attributes(
    0,
    "stretch",
    "stretch",
    new None(),
    "div",
    0,
    "static",
    new $option.None(),
    new $option.None(),
    new $option.None(),
    new $option.None(),
    new $option.None(),
  );
  return $list.fold(
    attrs,
    new$,
    (acc, val) => {
      if (val instanceof Gap) {
        let gap$1 = val[0];
        return new Attributes(
          gap$1,
          acc.align,
          acc.justify,
          acc.flex,
          acc.tag,
          acc.padding,
          acc.position,
          acc.overflow,
          acc.class,
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Align) {
        let align$1 = val[0];
        return new Attributes(
          acc.gap,
          align$1,
          acc.justify,
          acc.flex,
          acc.tag,
          acc.padding,
          acc.position,
          acc.overflow,
          acc.class,
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Justify) {
        let justify$1 = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          justify$1,
          acc.flex,
          acc.tag,
          acc.padding,
          acc.position,
          acc.overflow,
          acc.class,
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Flex) {
        let value = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          new Some(value),
          acc.tag,
          acc.padding,
          acc.position,
          acc.overflow,
          acc.class,
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Tag) {
        let tag$1 = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          acc.flex,
          tag$1,
          acc.padding,
          acc.position,
          acc.overflow,
          acc.class,
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Padding) {
        let padding$1 = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          acc.flex,
          acc.tag,
          padding$1,
          acc.position,
          acc.overflow,
          acc.class,
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Position) {
        let position$1 = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          acc.flex,
          acc.tag,
          acc.padding,
          position$1,
          acc.overflow,
          acc.class,
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Overflow) {
        let overflow$1 = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          acc.flex,
          acc.tag,
          acc.padding,
          acc.position,
          new Some(overflow$1),
          acc.class,
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Class) {
        let class$ = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          acc.flex,
          acc.tag,
          acc.padding,
          acc.position,
          acc.overflow,
          new Some(class$),
          acc.wrap,
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof Wrap) {
        let wrap$1 = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          acc.flex,
          acc.tag,
          acc.padding,
          acc.position,
          acc.overflow,
          acc.class,
          new Some(wrap$1),
          acc.whitespace,
          acc.shrink,
        );
      } else if (val instanceof WhiteSpace) {
        let whitespace = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          acc.flex,
          acc.tag,
          acc.padding,
          acc.position,
          acc.overflow,
          acc.class,
          acc.wrap,
          new Some(whitespace),
          acc.shrink,
        );
      } else {
        let shrink$1 = val[0];
        return new Attributes(
          acc.gap,
          acc.align,
          acc.justify,
          acc.flex,
          acc.tag,
          acc.padding,
          acc.position,
          acc.overflow,
          acc.class,
          acc.wrap,
          acc.whitespace,
          new Some(shrink$1),
        );
      }
    },
  );
}

export function row(row_attrs, attrs, children) {
  let styles$1 = compute_attributes(row_attrs);
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("row"),
      $css.align_items(styles$1.align),
      $css.justify_content(styles$1.justify),
      $css.gap(px(styles$1.gap)),
      $css.padding(px(styles$1.padding)),
      $css.position(styles$1.position),
      $css.overflow(
        (() => {
          let $ = styles$1.overflow;
          if ($ instanceof Some) {
            let value = $[0];
            return value;
          } else {
            return "visible";
          }
        })(),
      ),
      $css.flex(
        (() => {
          let $ = styles$1.flex;
          if ($ instanceof Some) {
            let value = $[0];
            return value;
          } else {
            return "initial";
          }
        })(),
      ),
      (() => {
        let $ = styles$1.wrap;
        if ($ instanceof Some) {
          let wrap$1 = $[0];
          return $css.flex_wrap(wrap$1);
        } else {
          return $css.none();
        }
      })(),
      (() => {
        let $ = styles$1.whitespace;
        if ($ instanceof Some) {
          let whitespace = $[0];
          return $css.white_space(whitespace);
        } else {
          return $css.none();
        }
      })(),
      (() => {
        let $ = styles$1.shrink;
        if ($ instanceof Some) {
          let shrink$1 = $[0];
          return $css.flex_shrink(shrink$1);
        } else {
          return $css.none();
        }
      })(),
      (() => {
        let $ = styles$1.class;
        if ($ instanceof $option.Some) {
          let class$ = $[0];
          return $css.compose(class$);
        } else {
          return $css.none();
        }
      })(),
    ]),
  );
  return ((_capture) => {
    return $s.styled(styles$1.tag, _capture, attrs, children);
  })(_pipe);
}

export function column(column_attrs, attrs, children) {
  let styles$1 = compute_attributes(column_attrs);
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.align_items(styles$1.align),
      $css.justify_content(styles$1.justify),
      $css.gap(px(styles$1.gap)),
      $css.padding(px(styles$1.padding)),
      $css.position(styles$1.position),
      $css.overflow(
        (() => {
          let $ = styles$1.overflow;
          if ($ instanceof Some) {
            let value = $[0];
            return value;
          } else {
            return "visible";
          }
        })(),
      ),
      $css.flex(
        (() => {
          let $ = styles$1.flex;
          if ($ instanceof Some) {
            let value = $[0];
            return value;
          } else {
            return "initial";
          }
        })(),
      ),
      (() => {
        let $ = styles$1.wrap;
        if ($ instanceof Some) {
          let wrap$1 = $[0];
          return $css.flex_wrap(wrap$1);
        } else {
          return $css.none();
        }
      })(),
      (() => {
        let $ = styles$1.whitespace;
        if ($ instanceof Some) {
          let whitespace = $[0];
          return $css.white_space(whitespace);
        } else {
          return $css.none();
        }
      })(),
      (() => {
        let $ = styles$1.class;
        if ($ instanceof $option.Some) {
          let class$ = $[0];
          return $css.compose(class$);
        } else {
          return $css.none();
        }
      })(),
    ]),
  );
  return ((_capture) => {
    return $s.styled(styles$1.tag, _capture, attrs, children);
  })(_pipe);
}
